module.exports = __webpack_public_path__ + "img/ico_social_linkedin--bl.5368ca40.svg";